import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AuthLayoutIndex from "../../layout/auth/AuthLayoutIndex";
import RootState from "../../redux/type";
import { loginUser, SET_TOKEN } from "../../redux/userAuth";
import { ALL_ROUTES } from "../../routes/AllRoutes";
import "../../styles/auth/Login.css";
import LoginMFAOtp from "./modals/LoginMFAOtp";
import RazorInputField from "../../components/razor-reuse/inputField/RazorInputField";

type detailsProps = {
  email: string;
  password: string;
};

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, token } = useSelector((state: RootState) => state.auth);

  const [details, setDetails] = useState<detailsProps>({
    email: "",
    password: "",
  });
  const [verifyMFA, setVerifyMFA] = useState(false); // For MFA OTP Verification Modal

  const handleChange = (e: any) => {
    e && e.preventDefault();
    const { name, value } = e?.target;

    const obj = { ...details, [name]: value };
    setDetails(obj);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    //  validations start ----------------
    // if (!validateEmail(details?.email)) {
    //   toast.error("Invalid email address!", {
    //     theme: "colored",
    //   });
    //   return;
    // }
    // if (
    //   !validatePasswordLowercase(details.password) &&
    //   !validatePasswordUpperCase(details.password) &&
    //   !validatePasswordSpecialCharacter(details.password) &&
    //   !validatePasswordNumber(details.password)
    // ) {
    //   toast.error(
    //     "Password should at least be 8 characters long,contain 1 capital letter, 1 lowercase letter,  1 special character,  1 numeric character.",
    //     {
    //       theme: "colored",
    //     }
    //   );
    //   return;
    // }
    // if (!validatePasswordLowercase(details.password)) {
    //   toast.error("Password should have at least 1 lowercase letter", {
    //     theme: "colored",
    //   });
    //   return;
    // }
    // if (!validatePasswordUpperCase(details.password)) {
    //   toast.error("Password should have at least 1 capital letter", {
    //     theme: "colored",
    //   });
    //   return;
    // }
    // if (!validatePasswordSpecialCharacter(details.password)) {
    //   toast.error("Password should have at least 1 special character", {
    //     theme: "colored",
    //   });
    //   return;
    // }
    // if (!validatePasswordNumber(details.password)) {
    //   toast.error("Password should have at least  1 numeric character.", {
    //     theme: "colored",
    //   });
    //   return;
    // }
    // validations end -----------------
    const obj = {
      ...details,
      remember: true,
    };
    const data = await dispatch(loginUser(obj) as any);
    if (data?.payload?.status) {
      // Check if the user enable 2FA
      if (data?.payload?.data?.user?.is_2fa_enabled === 1) {
        setVerifyMFA(true);
      } else {
        localStorage.setItem(
          "token",
          String(data?.payload?.data?.token || token)
        );
        navigate(ALL_ROUTES?.DASHBOARD_OVERVIEW);
        dispatch(SET_TOKEN(""));
      }
    }
    if (data?.payload?.response?.data?.status === "failed") {
      // const messg = data?.payload?.response?.data?.errors?.email;
      // toast.error(messg);
    }
  };

  return (
    <>
      <AuthLayoutIndex
        text={`Password should contain: Uppercase and \n lowercase letters, numbers, symbols`}
        title="Login to the BackOffice"
      >
        <>
          <div className="auth-login-wrapper-box">
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(e);
              }}
              className="form"
              autoComplete="off"
            >
              <RazorInputField
                color="black-light"
                type="email"
                label="Email"
                name="email"
                value={details?.email}
                onChange={handleChange}
                placeholder="Enter email"
              />
              <RazorInputField
                color="black-light"
                type="password"
                label="password"
                name="password"
                value={details?.password}
                onChange={handleChange}
                placeholder="Enter password"
              />
              {/* dont have account start */}
              <div
                style={{ marginTop: "-1.5rem", alignSelf: "flex-end" }}
                className="down-text-box"
              >
                <p className="text">
                  <span
                    onClick={() => {
                      navigate(ALL_ROUTES?.FORGOT_PASSWORD);
                    }}
                  >
                    Forgot password?
                  </span>
                </p>
              </div>
              {/* dont have account end */}
              <RazorInputField
                className="submit-btn"
                color="black-light"
                type="submit"
                value={`Login`}
                onSubmit={handleSubmit}
                disabled={!details?.email || !details?.password}
                loading={loading}
              />
            </form>
            {/* dont have account start */}
            <div style={{ marginTop: "3rem" }} className="down-text-box">
              <p className="text">
                Don't have an account?{" "}
                <span
                  onClick={() => {
                    navigate(ALL_ROUTES?.SIGN_UP);
                  }}
                >
                  Sign Up
                </span>
              </p>
            </div>
            {/* dont have account end */}
          </div>
          <LoginMFAOtp
            visible={verifyMFA}
            onClose={() => {
              setVerifyMFA(false);
            }}
          />
        </>
      </AuthLayoutIndex>
    </>
  );
};

export default Login;
